import { _ } from "../../../../core/polyglot/polyglot.js";
import { select } from "../../../../core/elements/index.js";
import { widget } from "@foretagsplatsen/widgetjs";
import regionWidget from "../../../../core/widgets/regionWidget.js";

/**
 *
 * `previousPeriodPickerWidget` is a dedicated dropDown used to select
 * the number of periods required to render KeyFigures information.
 *
 * @param {object} spec - Parameter object
 * @param {*[]} spec.periods - list of periods used to fill the dropDown
 * @param {object} my - protected fields holder
 * @return {*}
 */
function previousPeriodPickerWidget(spec, my) {
	spec ||= {};
	my ||= {};
	const that = widget(spec, my);

	const defaultPeriods = [
		{ label: _("1 period"), value: 1 },
		{ label: _("2 periods"), value: 2 },
		{ label: _("3 periods"), value: 3 },
		{ label: _("4 periods"), value: 4 },
		{ label: _("5 periods"), value: 5 },
		{ label: _("6 periods"), value: 6 },
		{ label: _("7 periods"), value: 7 },
		{ label: _("8 periods"), value: 8 },
		{ label: _("9 periods"), value: 9 },
		{ label: _("10 periods"), value: 10 },
		{ label: _("11 periods"), value: 11 },
		{ label: _("12 periods"), value: 12, selected: true },
		{ label: _("18 periods"), value: 18 },
		{ label: _("24 periods"), value: 24 },
		{ label: _("48 periods"), value: 48 },
		{ label: _("60 periods"), value: 60 },
	];

	my.previousPeriods = spec.periods || defaultPeriods;

	my.selectedPeriod = my.previousPeriods.find(
		(period) => period.selected,
	).value;

	my.onChangeCallback = () => {};

	my.previousPeriodSelect = regionWidget({
		content: (html) => {
			html.render(
				select({
					ref: (ref) =>
						ref.setAttribute("name", "previous-period-picker"),
					items: my.previousPeriods,
					selected: my.selectedPeriod,
					onChange: (value) => {
						my.selectedPeriod = value;
						my.onChangeCallback(value);
					},
				}),
			);
		},
	});

	that.setSelected = function (periodLength) {
		if (periodLength === my.selectedPeriod) {
			return;
		}

		const isPresentPredicate = (period) => period.value === periodLength;

		if (my.previousPeriods.some(isPresentPredicate)) {
			my.selectedPeriod = periodLength;
			my.previousPeriodSelect.update();
		}
	};

	that.getSelected = function () {
		return my.selectedPeriod;
	};

	that.onPeriodChange = function (callback) {
		my.onChangeCallback = callback;
	};

	that.renderContentOn = function (html) {
		html.render(my.previousPeriodSelect);
	};

	return that;
}

export default previousPeriodPickerWidget;
